// Import the functions you need from the SDKs you need
import { getApps, initializeApp } from "@firebase/app";
import "firebase/app-check";
import { browserLocalPersistence, connectAuthEmulator, getAuth, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { assertE2eFirebaseSafety } from "./emulatorGuard";



const firebaseConfig = {
  apiKey: "AIzaSyCNdiK6BjgeToOv6zZSwJrLCRWe02dIf_U",
  authDomain: "fiverrrms1.firebaseapp.com",
  databaseURL: "https://fiverrrms1-default-rtdb.firebaseio.com",
  projectId: "fiverrrms1",
  storageBucket: "fiverrrms1.appspot.com",
  messagingSenderId: "867766127997",
  appId: "1:867766127997:web:8afddf3d90c7793eb01014"
};


export default firebaseConfig;

const useFirebaseEmulator = process.env.REACT_APP_FIREBASE_EMULATOR === "1";
assertE2eFirebaseSafety({
  useEmulator: useFirebaseEmulator,
  e2e: process.env.REACT_APP_E2E === "1",
  projectId: firebaseConfig.projectId,
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app, "northamerica-northeast1");
let auth;
try {
  auth = initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  });
} catch (error) {
  auth = getAuth(app);
}

export function getCustomerAuth() {
  const name = "customer-order";
  const existing = getApps().find((item) => item.name === name);
  const customerApp = existing || initializeApp(firebaseConfig, name);
  return getAuth(customerApp);
}

// Initialize Storage with explicit app instance to ensure auth context is shared
const storage = getStorage(app);
const database = getDatabase(app);

if (useFirebaseEmulator) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectDatabaseEmulator(database, "127.0.0.1", 9000);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}

// Enable Firestore persistence for offline support
// This allows Firestore to cache data locally
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled in one tab at a time
    console.warn('Firestore persistence already enabled in another tab');
  } else if (err.code === 'unimplemented') {
    // Browser doesn't support persistence
    console.warn('Firestore persistence not supported in this browser');
  } else {
    console.error('Error enabling Firestore persistence:', err);
  }
});

export { app, auth, db, functions, storage };
